import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a small table lamp, authored at floor level (the builder sets
// it on a table): a brass disc base, a short stem and a fabric drum shade.
const BRASS = "#c9a35a";
const FABRIC = "#e8e0d2";
const GLOW = "#f5e9c8";

const SHADE_TOP = 0.45;
const SHADE_H = 0.17;

export const tableLamp = defineModel({
  id: "table-lamp",
  batchId: "modern",
  name: "Table lamp",
  tags: ["modern", "interior", "fixture", "lighting", "decor"],
  summary: "A small brass-stemmed table lamp with a fabric drum shade.",
  tiles: { w: 1, h: 1 },
  footprint: 0.6,
  parts(): Part[] {
    return [
      // Disc base.
      { geometry: new THREE.CylinderGeometry(0.09, 0.1, 0.02, 14), color: BRASS,
        position: [0, 0.01, 0] },
      // Short stem.
      { geometry: new THREE.CylinderGeometry(0.012, 0.012, SHADE_TOP - SHADE_H - 0.02, 8), color: BRASS,
        position: [0, 0.02 + (SHADE_TOP - SHADE_H - 0.02) / 2, 0] },
      // Fabric drum shade, slightly tapered.
      { geometry: new THREE.CylinderGeometry(0.1, 0.12, SHADE_H, 14), color: FABRIC,
        position: [0, SHADE_TOP - SHADE_H / 2, 0] },
      // Glow-tone underside disc.
      { geometry: new THREE.CylinderGeometry(0.08, 0.08, 0.015, 12), color: GLOW,
        position: [0, SHADE_TOP - SHADE_H - 0.004, 0] },
    ];
  },
  animations: [],
});
